export const ASSETS_GET_ASSETSLIST = "assets/get-assets-list";
